import React from 'react';
import { HeaderContainer } from '../../organisms/common/headerContainer';
import ScrollToTop from '../../atoms/scrollToTop';
import '../../../resources_membership_hotel/css/common/common.css';
import RestaurantListContainer from '../../organisms/esthetic/restaurantListContainer';
import RestaurantListDetailPopupContainer from '../../organisms/esthetic/restaurantListDetailPopupContainer';
import MembershipReservationPopupContainer from '../../organisms/common/membershipReservationPopupContainer';
import RestaurantUserPopupContainer from '../../organisms/esthetic/restaurantUserPopupContainer';
import { MemberShipImportedCheck } from '../../../util/memberShipImportedCheck';


class RestaurantReserveAllTemplate extends React.Component {

  render() {
    return (
      <>
        <ScrollToTop />
        <MemberShipImportedCheck
          state={this.props.state}
          setKaiinkenFlg={this.props.setKaiinkenFlg}
        />
        <HeaderContainer
          Label categoryLabel1={"レストラン予約"}
          categoryLabel2={"RESTAURANT"}
          path={"/reserve/top"}
          bookedConfirmLabel={"＞予約内容の確認・変更・キャンセルはこちら"}
          importedFlg={true}
          onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
        />
        <RestaurantListContainer
          state={this.props.state}
          onClickOpenPopupWindow={this.props.onClickOpenPopupWindow}
          onClickOpenMessageWindow={this.props.onClickOpenMessageWindow}
          setPopupMessage={this.props.setPopupMessage}
          setKaiinkenFlg={this.props.setKaiinkenFlg}
        />
        <RestaurantListDetailPopupContainer
          state={this.props.state}
          onClickOpenPopupWindow={this.props.onClickOpenPopupWindow}
          onClickOpenMessageWindow={this.props.onClickOpenMessageWindow}
          onClickClosePopupWindow={this.props.onClickClosePopupWindow}
          setKaiinkenFlg={this.props.setKaiinkenFlg}
        />
        <MembershipReservationPopupContainer
          state={this.props.state}
          onClickClosePopupWindow={this.props.onClickCloseReservationConfPopupWindow}
        />
        <RestaurantUserPopupContainer
          state={this.props.state}
          onClickClosePopupWindow={this.props.onClickClosePopupWindow}
        />
      </>
    )
  }
}
export default RestaurantReserveAllTemplate;
